import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { PoweredByHiptravelerComponent } from './powered-by-hiptraveler.component';

const MODULES = [
  CommonModule,
  TranslateModule
];

const COMPONENTS = [
  PoweredByHiptravelerComponent
];

@NgModule({
  imports: [
    MODULES
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    PoweredByHiptravelerComponent
  ]
})
export class PoweredByHiptravelerModule { }
